import { ChangeEvent, useCallback } from "react";
import useWatchState from "../../../hooks/useWatchState";

export const useCheckbox = (
  checked: boolean,
  onChange: (event: ChangeEvent<HTMLInputElement>) => void,
): [boolean, (event: ChangeEvent<HTMLInputElement>) => void] => {
  const [isChecked, setChecked] = useWatchState({ value: checked ?? false });

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>): void => {
      setChecked(event.target.checked);
      onChange && onChange(event);
    },
    [onChange, setChecked],
  );

  return [isChecked, handleChange];
};
